<template>
	<div class="comp">
		<el-dialog :title="'用法用量'" :visible.sync="dialogState" width="500px" @close="close">
			<el-form >
				<el-form-item label="用法" :label-width="'100px'">
					<el-select v-model="yfyl.yongfa" placeholder="请选择" size="mini" style="width:140px;">
						<el-option
						v-for="item in [{label:'内服',value:'内服'},{label:'外敷',value:'外敷'},{label:'注射',value:'注射'},{label:'其他',value:'其他'}]"
						:key="item.value"
						:label="item.label"
						:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="频次" :label-width="'100px'">
					<el-input v-model="yfyl.yongliang1" @input="input" style="width:50px;" size="mini">
					</el-input>
					天
					<el-input v-model="yfyl.yongliang2" @input="input" style="width:50px;" size="mini">
					</el-input>
					次
				</el-form-item>
				<el-form-item label="用量" :label-width="'100px'">
					<el-input v-model="yfyl.yongliang3" @input="input" style="width:60px;margin-right: 4px;" size="mini">
					</el-input>
					<el-select style="width:75px;margin: -10px 0;" v-model="yfyl.yongliang4" placeholder="请选择" size="mini">
						<el-option
						v-for="item in [
							{label:'片',value:'片'},
							{label:'粒',value:'粒'},
							{label:'ml',value:'ml'},
							{label:'mg',value:'mg'},
							{label:'g',value:'g'},
							{label:'kg',value:'kg'},
							{label:'支',value:'支'},
							{label:'瓶',value:'瓶'},
							{label:'测',value:'测'},
							{label:'袋',value:'袋'},
							{label:'份',value:'份'},
							{label:'头份',value:'头份'},
							{label:'iu',value:'iu'},
							{label:'ug',value:'ug'},
							{label:'单位',value:'单位'},
						]"
						:key="item.value"
						:label="item.label"
						:value="item.value">
						</el-option>
					</el-select>
					<span style=""> / 次</span>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="close">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				dialogState:false,
				
				yfyl:{
					yongfa:'',
					yongliang1:'1',
					yongliang2:'',
					yongliang3:'',
					yongliang4:'',
				},
			}
		},
		computed:{
		},
		props:{
			row:{
				default:()=>{
					return {}
				}
			}
		},
		mounted() {
			this.$nextTick(()=>{
				this.dialogState = true
			})
			if(this.row.goodsUsage.length===5){
				this.yfyl.yongfa = this.row.goodsUsage[0]
				this.yfyl.yongliang1 = this.row.goodsUsage[1]
				this.yfyl.yongliang2 = this.row.goodsUsage[2]
				this.yfyl.yongliang3 = this.row.goodsUsage[3]
				this.yfyl.yongliang4 = this.row.goodsUsage[4]
			}
		},
		methods: {
			close(){
				this.$emit("submit",{type:"close"})
			},
			input(){
				this.yfyl.yongliang1 = this.$public.replaceGoodsDosage(this.yfyl.yongliang1)
				this.yfyl.yongliang2 = this.$public.replaceGoodsDosage(this.yfyl.yongliang2)
				this.yfyl.yongliang3 = this.$public.replaceGoodsDosage(this.yfyl.yongliang3)
			},
			submit(){
				if(
					this.$public.isNull(this.yfyl.yongfa)||
					this.$public.isNull(this.yfyl.yongliang1)||
					this.$public.isNull(this.yfyl.yongliang2)||
					this.$public.isNull(this.yfyl.yongliang3)||
					this.$public.isNull(this.yfyl.yongliang4)
				){
					this.$message({
						message: '用法用量输入不完整',
						type: 'error'
					})
					return
				}
				let params = {
					"goodsItemsId": this.row.itemsId,
					"goodsUsage": [this.yfyl.yongfa, this.yfyl.yongliang1, this.yfyl.yongliang2, this.yfyl.yongliang3, this.yfyl.yongliang4],
				}
				let loading = this.$loading()
				this.$http.post('/api/Case/Goods/goodsUsage', params).then(res => {
					loading.close();
					if(res.code===0){
						this.$emit("submit",{type:"success"})
					}
				})
			}
		}
	}
</script>
<style lang="scss" scoped>
	.comp {
		.label{
			font-size: 14px;font-weight: bold;padding:20px 0 1px;
		}
		::v-deep.el-dialog__body{
			padding-top:10px;
		}
	}
</style>
